import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { addThousandsSeparator } from "@/src/utils/numberUtils";

interface ImageCarouselItemProps {
  image: {
    url: string;
    model: string;
    price: number;
  };
  hasRoundBorders?: boolean;
}

const ImageCarouselItem = ({
  image,
  hasRoundBorders
}: ImageCarouselItemProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "390px",
        position: "relative",
        overflow: "hidden",
        borderRadius: hasRoundBorders ? "40px" : "4px",
        backgroundColor: theme.palette.common.black
      }}
    >
      <Box
        component="img"
        src={image.url}
        alt={image.model}
        draggable={false}
        loading="lazy"
        sx={{
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center"
        }}
      />
      <Box
        sx={{
          width: "100%",
          position: "absolute",
          bottom: "0",
          background: theme.palette.action.disabledBackground
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
            zIndex: 2,
            color: theme.palette.common.white,
            mb: 0.5
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              mr: 2
            }}
          >
            {image.model}
          </Typography>
          <Typography variant="subtitle2">
            {addThousandsSeparator(image.price)} {"€"}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: 50,
            position: "absolute",
            bottom: "0",
            color: theme.palette.common.white,
            background: theme.palette.text.primary,
            maskImage: `linear-gradient(to bottom, transparent, 40%, ${theme.palette.misc.outlineBorder})`,
            borderRadius: hasRoundBorders ? "0px 0px 40px 40px" : "0"
          }}
        />
      </Box>
    </Box>
  );
};

export default ImageCarouselItem;
